import { Component } from 'react'

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-4 text-red-600 bg-red-50 rounded">
          <h2>Something went wrong</h2>
          <pre className="mt-2 text-sm">{this.state.error?.message}</pre>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary 